import * as WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Barlow:400,600,800', 'Material Icons']
  }
});
